import { Analytics } from "utils/analytics"
import { HelpTooltip, SupportDescription } from "components"
import { ErrorPage } from "modules/Booking/ErrorPage"

export function ErrorPageWrapper() {
    return (
        <ErrorPage
            headline="Произошла ошибка"
            secondary={
                <>
                    Попробуйте снова или обратитесь в службу поддержки
                    <span className="booking__error-support-tooltip-image">
                        <HelpTooltip
                            overlay={
                                <SupportDescription
                                    lang="ru"
                                    onClickMail={() => Analytics.support_tooltip_email_clicked()}
                                    onClickTelegram={() =>
                                        Analytics.support_tooltip_telegram_clicked()
                                    }
                                    className="is-dark"
                                />
                            }
                        />
                    </span>
                </>
            }
            tryAgain
        />
    )
}
